import { useLang } from "@/context/LanguageContext";
import { Check, Sparkles } from "lucide-react";

export default function Showcase() {
  const { t } = useLang();
  const bullets = [
    t.showcase.bullet_1,
    t.showcase.bullet_2,
    t.showcase.bullet_3,
    t.showcase.bullet_4,
  ];

  return (
    <section
      id="showcase"
      data-testid="showcase-section"
      className="relative py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        {/* Image */}
        <div className="lg:col-span-6 relative">
          <div
            data-testid="showcase-image"
            className="overflow-hidden bg-[#D1FAE5] aspect-[4/5] md:aspect-[5/6]"
            style={{
              borderRadius: "55% 45% 50% 50% / 45% 55% 45% 55%",
            }}
          >
            <img
              src="https://images.unsplash.com/photo-1776245228843-7fc058aa19a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBib3V0aXF1ZSUyMGhvdGVsJTIwaW50ZXJpb3IlMjBjb3p5fGVufDB8fHx8MTc3ODE2ODE3MHww&ixlib=rb-4.1.0&q=85"
              alt="Stylish hospitality lounge"
              className="w-full h-full object-cover"
            />
          </div>
          <div
            data-testid="showcase-badge"
            className="absolute top-8 right-2 md:right-8 bg-[#F59E0B] text-[#064E3B] rounded-2xl shadow-xl px-5 py-3 flex items-center gap-2 -rotate-[6deg]"
          >
            <Sparkles className="w-4 h-4" />
            <span className="font-heading text-sm font-black uppercase tracking-wide">
              5★ Stays
            </span>
          </div>
        </div>

        {/* Copy */}
        <div className="lg:col-span-6">
          <span className="font-body text-sm uppercase tracking-widest font-bold text-[#22C55E]">
            {t.showcase.eyebrow}
          </span>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl font-extrabold tracking-tight text-[#064E3B] leading-[1.05]">
            {t.showcase.title}
          </h2>
          <p className="mt-5 font-body text-lg md:text-xl text-[#047857] leading-relaxed">
            {t.showcase.subtitle}
          </p>

          <ul className="mt-8 space-y-4">
            {bullets.map((b, i) => (
              <li
                key={i}
                data-testid={`showcase-bullet-${i}`}
                className="flex items-start gap-3"
              >
                <span className="mt-1 w-6 h-6 rounded-full bg-[#22C55E] flex items-center justify-center shrink-0">
                  <Check className="w-3.5 h-3.5 text-white" strokeWidth={3} />
                </span>
                <span className="font-body text-base md:text-lg text-[#064E3B]">
                  {b}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
